<template>
  <div class="test-view">
    <!-- Demo：在企业微信内置浏览器中点击，调用 store.joinGroup → openEnterpriseChat -->
    <div class="demo-btn" @click="addGroup">拉群</div><br>
    <div class="demo-btn mt10" @click="updateEnterpriseChat">加群</div>
    <div class="demo-btn mt10" @click="joinOtherGroup">加入别人的群</div>

    <div class="demo-btn mt10" @click="continuousAddGroup">连续加群</div>
    <div>v4</div>

  
 </div>
</template>

<script>
import { userStore } from "@/store/user.js";
import { showToast } from "vant";

export default {
  name: "Test",
  data() {
    return {};
  },
  methods: {
    /**
     * 演示拉群：参数先写死，直接调用 store.joinGroup
     * 正式环境建议改为：从业务接口/选人组件获取参数后再传入
     */
     addGroup() {
      const userPiniaStore = userStore();
      const FIXED_JOIN_GROUP_PARAMS = {
        userIds: "BeiCheng;BangBangDa",
        externalUserIds: "wmTzNNWgAAhYJOPlWbOROGx6ByURxh-A",
        groupName: "讨论组1",
        chatId: "",
      };

      userPiniaStore
        .joinGroup(FIXED_JOIN_GROUP_PARAMS)
        .then((openRes) => {
          // 3.0.36+ 版本回调中可能返回 chatId
          console.log("openEnterpriseChat 成功", openRes);
          showToast("拉群调用成功");
        })
        .catch((openErr) => {
          console.warn("openEnterpriseChat 失败", openErr);
          showToast("拉群调用失败");
        });
    },
    updateEnterpriseChat(){
      const userPiniaStore = userStore();
      const FIXED_ADD_GROUP_MEMBER_PARAMS = {
        chatId: "wrTzNNWgAAM6Abh5f1A_UDo2luo2vTCQ",
        userIdsToAdd: "ZouYanRong",
      };

      userPiniaStore
        .updateGroupMember(FIXED_ADD_GROUP_MEMBER_PARAMS)
        .then((updateRes) => {
          console.log("updateEnterpriseChat 成功", updateRes);
          showToast("不打开加群调用成功");
        })
        .catch((updateErr) => {
          console.warn("updateEnterpriseChat 失败", updateErr);
          showToast("不打开加群调用失败");
        });
    },
    joinOtherGroup(){
      const userPiniaStore = userStore();
      const FIXED_ADD_GROUP_MEMBER_PARAMS = {
        chatId: "wrTzNNWgAAOwz7Hf6Y9hP2XTlrBEux9Q",
        userIdsToAdd: "BeiCheng",
      };

      userPiniaStore
        .updateGroupMember(FIXED_ADD_GROUP_MEMBER_PARAMS)
        .then((updateRes) => {
          console.log("updateEnterpriseChat 成功", updateRes);
          showToast("不打开加群调用成功");
        })
        .catch((updateErr) => {
          console.warn("updateEnterpriseChat 失败", updateErr);
          showToast("不打开加群调用失败");
        });
    },
     /**
     * 连续加群示例：
     * 1) 用数组队列保存每次“加人”的入参
     * 2) 通过 updateGroupMember 的回调，在“当前加人成功后”再执行下一个
     */
     continuousAddGroup() {
      const userPiniaStore = userStore();

      // 连续加人队列（示例数据：chatId / userIdsToAdd）
      const TEST_ADD_GROUP_MEMBER_QUEUE = [
        {
          chatId: "wrwWdtKQAArHO1G0vhvtSjh1-iQarTzQ",
          userIdsToAdd: "LiHong",
        },
        {
          chatId: "wrwWdtKQAAJWc8QBT9NLosQ-QtHmAMQA",
          userIdsToAdd: "LiHong",
        },
        {
          chatId: "wrwWdtKQAAUANSZWMEyGaRRNsE20lQCg",
          userIdsToAdd: "LiHong",
        },
      ];

      // 用下标控制执行顺序，确保前一个群加人成功后才会继续下一个
      let currentQueueIndex = 0;

      const runNextAddGroup = () => {
        // 队列全部处理完成
        if (currentQueueIndex >= TEST_ADD_GROUP_MEMBER_QUEUE.length) {
          showToast("连续加群已完成");
          return;
        }

        const currentAddGroupParams =
          TEST_ADD_GROUP_MEMBER_QUEUE[currentQueueIndex];

        // 用于避免“回调已经推进队列”时，catch 又重复推进/执行
        let isQueueAdvancedByCallback = false;

        userPiniaStore
          .updateGroupMember(currentAddGroupParams, () => {
            isQueueAdvancedByCallback = true;
            currentQueueIndex += 1;
            runNextAddGroup();
          })
          .then((updateRes) => {
            // 注意：此时通常“回调”已触发并推进队列
            console.log(
              "连续加群成功",
              currentAddGroupParams,
              updateRes,
            );
          })
          .catch((updateErr) => {
            console.warn(
              "连续加群失败，队列已停止",
              currentAddGroupParams,
              updateErr,
            );
            showToast(
              `连续加群失败，第 ${currentQueueIndex + 1} 个已跳过，继续执行下一项`,
            );

            // 如果回调没有推进队列，则在失败后手动推进并继续
            if (!isQueueAdvancedByCallback) {
              currentQueueIndex += 1;
              runNextAddGroup();
            }
          });
      };

      runNextAddGroup();
    },
  },
};
</script>

<style scoped>
.test-view {
  padding: 24px;
}
.demo-btn {
  display: inline-block;
  padding: 10px 20px;
  color: #fff;
  font-size: 14px;
  background-color: #28b8c3;
  border-radius: 4px;
  cursor: pointer;
}
</style>
